require('./accountDebitsEditSuccessStep.scss');

const PropTypes = require('prop-types');
const React = require('react');
// @ commons
const { formatText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
// @ constants
const linkLabel = formatText('debitsEdit-successLink');

const AccountDebitsEditSuccessStep = props => {
    const { accountId, alias, newAlias } = props
    const injectedStrings = [alias, newAlias];
    const link = `/myprofile/accounts/${accountId}/debits`;
    const goBackButton = {
        label: linkLabel,
        url: link
    }
    const title = formatText('debitsEdit-successTitle', injectedStrings);
    return (
        <WizardSuccess
            successMessage={title}
            mainButton={goBackButton}
        />
    );
};

AccountDebitsEditSuccessStep.propTypes = {
    accountId: PropTypes.string,
    alias: PropTypes.string,
    newAlias: PropTypes.string
}

module.exports = AccountDebitsEditSuccessStep;